var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6825 8.33998C15.6825 12.0075 13.02 15.4425 9.38252 16.4475C9.13502 16.515 8.865 16.515 8.6175 16.4475C4.98 15.4425 2.3175 12.0075 2.3175 8.33998V5.04747C2.3175 4.43246 2.78252 3.73497 3.36002 3.50247L7.5375 1.79249C8.475 1.40999 9.5325 1.40999 10.47 1.79249L14.6475 3.50247C15.2175 3.73497 15.69 4.43246 15.69 5.04747L15.6825 8.33998Z",
    stroke: "currentColor",
    strokeWidth: 1.18636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.8290ea9b0ced5ca0df6bdb40b72e3ef6.svg";
export { ForwardRef as ReactComponent };